import useFetchApi from "@/api/hooks/useFetchApi";
import useLocale from "@/locales/hooks/useLocale";
import { useEffect, useState } from "react";
import ReactCountryFlag from "react-country-flag";



const LocaleSelector = () => {
    const {
        locale,
        setLocale
    } = useLocale();

    const [selectedMember, setSelectedMember] = useState<any>(null);

    const {
        data: members,
        isLoading,
        error,
        isValidating,
        mutate,
    } = useFetchApi({
        url: `/v1/gp/674414d5701373e4a78d96be`,
        service: "CMS_PROC"
    });

    useEffect(() => {
        if (members) {
            let member = members.members.find((member: any) => member.key === locale);
            if (member) {
                setSelectedMember(member);
            }
        }
    }, [locale, isLoading]);

    return (
        <>
            <a href="#" className="dropdown-toggle" data-toggle="dropdown">
                <i className="fa fa-globe"></i>

                {selectedMember ? (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 6,
                        }}
                    >
                        <ReactCountryFlag countryCode={selectedMember.key} svg />
                        <span>
                            {selectedMember.name}
                        </span>
                    </div>
                ) : null}
            </a>
            <ul className="dropdown-menu">
                {
                    members?.members?.map((member: any) => {
                        return (
                            <li
                                key={member._id}
                            >
                                <button
                                    onClick={
                                        (e) => {
                                            e.preventDefault();
                                            setLocale(member.key);
                                        }
                                    }
                                    style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                    <ReactCountryFlag countryCode={
                                        member.key ? member.key : "TR"
                                    } svg />
                                    {member.name}
                                </button>
                            </li>
                        );
                    })
                }

            </ul>
        </>
    );
}

export default LocaleSelector;